import { TOKEN_SCOPES } from '@/router/routerData'
export const isFullAccessLogin = (state) => state.userTokenScope.includes(TOKEN_SCOPES.FULL_ACCESS)
